<div class="w-full mx-auto">
  <div class="flex flex-row">
    <div class="sidebar xl:block hidden basis-1/4 h-screen">
      <div id="particles" class="p-12">
        <div class="relative w-full h-full">
          <div class="text-white">
            <h1>
              <a class="logo-link" routerLink="/">
                <img class="w-full" src="assets/logos/app-logo-white.svg" alt="LOGO" />
                <span class="claim">{{ env.brandConfig?.mottoText }}</span>
              </a>
            </h1>
          </div>
        </div>
      </div>
    </div>
    <main class="w-full xl:basis-3/4 h-screen">
      <div class="w-full h-full">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
<div class="version">{{ version }}</div>
